import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ToastType = 'error' | 'success' | 'info';

interface ToastState {
    type: ToastType;
    message: string;
    visible: boolean;
}

export const initialState: ToastState = {
    type: 'info',
    message: '',
    visible: false,
};

const toastSlice = createSlice({
    name: 'toast',
    initialState,
    reducers: {
        showToast: (state, action: PayloadAction<{ type: ToastType; message: string }>) => {
            state.type = action.payload.type;
            state.message = action.payload.message;
            state.visible = true;
        },
        hideToast: (state) => {
            state.visible = false;
            state.message = '';
        },
    },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
